<div class="accessCodeAlert">
  <p>{{'access-code.access_codes_are_converted' | translate}}</p>
  <div class="spinner-border m-2 customSpinner" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
